import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { DateTime } from 'luxon'
import ReportForm, { ReportPeriod } from './ReportForm'
import BaseDropdown from '../../../../components/Dropdown/BaseDropdown'
import SortDropdown, { Direction } from '../../../../components/Dropdown/SortDropdown'
import { getDropdownProps } from '../../../../helpers/formHelper'
import { Stack } from '@fluentui/react'
import { DocumentGenerationType } from '../../../../hooks/document/documentGenerationTypes'
import DateRange from '../../../DatePicker/DateRange'
import UserPicker, { UserPickerProps } from '../../../TagPicker/UserPicker'
import FormikComboboxField from '../../../Formik/FormikComboboxField'
import { BilledTurnoverDto } from './BilledTurnoverReportForm'
import { ReportFormType } from '../../../../pages/Finance/Reports'

export type UserProductivityDto = {
    from: string
    to: string
    users: string[]
    cluster: ReportPeriod
    sorting: Direction
}

function ReportBody(props: ReportFormType): ReactElement {
    const { errors, values, setFieldValue } = useFormikContext<UserProductivityDto>()

    return (
        <Stack>
            <DateRange
                startValue={values.from}
                endValue={values.to}
                changeStartDate={date => setFieldValue('from', date)}
                changeEndDate={date => setFieldValue('to', date)}
                orientation={props.orientation}
                required
                showLabel
                validationMessage={errors.from || errors.to}
            />
            <FormikComboboxField<BilledTurnoverDto, UserPickerProps>
                orientation={props.orientation}
                labelKey="file.filter.executive"
                fieldName={'users'}
                component={UserPicker}
            />
            <BaseDropdown
                {...getDropdownProps(values.cluster, undefined, value => setFieldValue('cluster', value), false)}
                required={false}
                label={'Periodisering'}
                canClear={false}
                options={[
                    { key: ReportPeriod.Day, text: 'Dag' },
                    { key: ReportPeriod.Week, text: 'Week' },
                    { key: ReportPeriod.Month, text: 'Maand' },
                    { key: ReportPeriod.Year, text: 'Jaar' },
                ]}
            />
            <SortDropdown {...getDropdownProps(values.sorting, undefined, value => setFieldValue('sorting', value), false)} />
        </Stack>
    )
}

export default function UserProductivityForm(props: ReportFormType): ReactElement {
    return (
        <ReportForm<UserProductivityDto>
            title="Productiviteit per gebruiker"
            generationType={DocumentGenerationType.UserProductivity}
            initialValues={{
                users: [],
                from: DateTime.local().minus({ months: 12 }).startOf('month').toISODate(),
                to: DateTime.local().toISODate(),
                cluster: ReportPeriod.Month,
                sorting: Direction.Ascending,
            }}
            {...props}
        >
            <ReportBody {...props} />
        </ReportForm>
    )
}
